import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "wo-capability-manager"
};
const _hoisted_2 = {
  class: "grid-container"
};
const _hoisted_3 = ["onClick"];
const _hoisted_4 = {
  class: "title"
};
const _hoisted_5 = {
  class: "explain"
};
import { ref, computed, onMounted } from 'vue';
import { ElIcon, ElInput, ElMessage, ElRow } from "element-plus";
import { Plus } from "@element-plus/icons-vue";
import store from "@/store";
import { request } from "@/manager/net_manager";
import { getProperty, isAdminType } from "@/tools/utils";
import MaskerLayer from "@/components/Basic/MaskerLayer.vue";
import CapabilityEditCard from "@/components/Capability/CapabilityEditCard.vue"; // refs

export default {
  __name: 'WOCapabilityManager',

  setup(__props) {
    const capabilities = ref([]);
    const capability = ref(null);
    const version = ref(''); // computed

    const userType = computed(() => store.state.user ? parseInt(store.state.user.user_type) : 4);
    const appInfo = computed(() => store.state.app_info); // functions

    const getData = () => {
      getVersionData();
      request('capabilities/list/', {}, 'GET').then(response => {
        // console.log(JSON.stringify(response))
        if (response.code !== 0) {
          ElMessage.error({
            message: response.msg,
            duration: 1500
          });
          return;
        }

        capabilities.value = response.data.sort((a, b) => {
          return b.capability_id - a.capability_id;
        });
      });
    };

    const getVersionData = () => {
      request('basic/app_info/', {}, 'GET').then(response => {
        // console.log(JSON.stringify(response))
        if (response.code !== 0) {
          ElMessage.error({
            message: response.msg,
            duration: 1500
          });
          return;
        }

        store.commit('update_app_info', response.data);
      });
    };

    const editCapability = item => {
      if (!isAdminType(userType.value)) return;
      capability.value = item;
    };

    const generateConfig = () => {
      if (!version.value || version.value.length === 0) {
        ElMessage.error({
          message: '需要版本号',
          duration: 1500
        });
        return;
      }

      request('capabilities/config/generate/', {
        'version': version.value
      }, 'POST').then(response => {
        // console.log(JSON.stringify(response))
        if (response.code !== 0) {
          ElMessage.error({
            message: response.msg,
            duration: 1500
          });
          return;
        }

        version.value = '';
        ElMessage.success({
          message: '已生成配置文件',
          duration: 1500
        });
        getVersionData();
      });
    };

    const downloadConfig = () => {
      if (!appInfo.value || !appInfo.value?.capability_info?.file) return;
      const url = appInfo.value?.capability_info?.file ?? '';
      request(url, {
        'name': 'capability_configure'
      }, 'DOWNLOAD', {}, false);
    };

    const getCapabilityName = item => {
      const name = `${item?.desc}/${item?.name}`;

      if (item.extraordinary) {
        return `${name}【超凡】`;
      }

      return name;
    };

    const getCapabilityBaseValueDesc = baseValue => {
      if (typeof baseValue === 'number' || !baseValue.includes(',')) {
        return baseValue;
      }

      const parts = baseValue.split(',').map(part => part.trim());

      if (parts.length === 2 && !isNaN(parts[0])) {
        let numericPart = parseFloat(parts[0]);
        let variablePart = getProperty(parts[1]);
        return `${numericPart} * ${variablePart}`;
      }
    }; // lifecycle


    onMounted(() => {
      getData();
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_unref(isAdminType)(userType.value) && appInfo.value ? (_openBlock(), _createBlock(_unref(ElRow), {
        key: 0,
        style: {
          "justify-content": "flex-end",
          "align-items": "center",
          "gap": "16px"
        }
      }, {
        default: _withCtx(() => [_createElementVNode("text", null, "当前配置版本：" + _toDisplayString(appInfo.value?.capability_info?.version), 1), _createVNode(_component_el_button, {
          onClick: downloadConfig
        }, {
          default: _withCtx(() => [...(_cache[4] || (_cache[4] = [_createTextVNode(" 下载 ", -1)]))]),
          _: 1
        })]),
        _: 1
      })) : _createCommentVNode("", true), _unref(isAdminType)(userType.value) ? (_openBlock(), _createBlock(_unref(ElRow), {
        key: 1,
        style: {
          "justify-content": "flex-end",
          "gap": "16px"
        }
      }, {
        default: _withCtx(() => [_createVNode(_unref(ElInput), {
          modelValue: version.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => version.value = $event),
          maxlength: "11",
          placeholder: "配置版本",
          round: "",
          type: "text",
          clearable: "",
          "show-word-limit": ""
        }, null, 8, ["modelValue"]), _createVNode(_component_el_button, {
          onClick: generateConfig
        }, {
          default: _withCtx(() => [...(_cache[5] || (_cache[5] = [_createTextVNode(" 更新能力配置文件 ", -1)]))]),
          _: 1
        })]),
        _: 1
      })) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_2, [_unref(isAdminType)(userType.value) ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "create-capability-card",
        onClick: _cache[1] || (_cache[1] = $event => editCapability({}))
      }, [_createVNode(_unref(ElIcon), {
        size: "14"
      }, {
        default: _withCtx(() => [_createVNode(_unref(Plus))]),
        _: 1
      }), _cache[6] || (_cache[6] = _createElementVNode("text", null, "创建新能力", -1))])) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(capabilities.value, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          class: _normalizeClass(["capability-card", item.extraordinary ? 'extraordinary' : '']),
          onClick: $event => editCapability(item)
        }, [_createElementVNode("text", _hoisted_4, _toDisplayString(getCapabilityName(item)), 1), _cache[7] || (_cache[7] = _createElementVNode("div", {
          class: "divider"
        }, null, -1)), item && item?.type ? (_openBlock(), _createBlock(_unref(ElRow), {
          key: 0,
          class: "type-desc"
        }, {
          default: _withCtx(() => [_createElementVNode("text", null, _toDisplayString(item?.type?.desc) + " / " + _toDisplayString(item?.type?.name), 1), _createElementVNode("text", null, " 基础值：" + _toDisplayString(getCapabilityBaseValueDesc(item?.base_value ?? '')), 1)]),
          _: 2
        }, 1024)) : _createCommentVNode("", true), _createElementVNode("text", _hoisted_5, _toDisplayString(item?.explain), 1)], 10, _hoisted_3);
      }), 128))]), capability.value !== null ? (_openBlock(), _createBlock(MaskerLayer, {
        key: 2,
        onClose: _cache[3] || (_cache[3] = $event => capability.value = null)
      }, {
        default: _withCtx(() => [_createVNode(CapabilityEditCard, {
          capability: capability.value,
          onReload: getData,
          onClose: _cache[2] || (_cache[2] = $event => capability.value = null)
        }, null, 8, ["capability"])]),
        _: 1
      })) : _createCommentVNode("", true)]);
    };
  }

};